<template>
  <div style="background-color: whitesmoke !important;">
    <menu-superior titulo="PESQUISAR" id="menusuperior-pesquisa"></menu-superior>
    <div class="container">
      <form >
        <div class="row">
          <div class="input-field col s10">
            <i class="material-icons prefix">search</i>
            <textarea id="icon_prefix2" class="materialize-textarea" :value='termoBusca' @input='evt=>termoBusca=evt.target.value' v-on:keyup="Pesquisar"></textarea>
            <label for="icon_prefix2">Pesquisar</label>
          </div>
          <div class="col s2" style="padding: 19px 0rem 0 0;" @click="Pesquisar()">
            <a class="waves-effect waves-light btn-small" :style="'background-color: '+this.$store.state.empresa.cor_primaria"><span style="font-weight: 700"><i class="material-icons">search</i></span></a>
          </div>
        </div>
      </form>
    </div>
    <div class="container page-section" >
      <div class="row">
        <card v-for="produto in orderProdutos(produtosFiltro, tipoOrdem)" :produto="produto" :key="'itempromocaoa-'+produto.id" ></card>
      </div>
    </div>

  </div>
</template>

<script>
  import MenuSuperior from "./template/MenuSuperior";
  import TituloDestacado from "./template/TituloDestacado";
  import Card from "../components/Card";
  import SecureLS from "secure-ls";
  import ProdutosContainerFlex from "../components/ProdutosContainerFlex";

  export default {
    name: "ProductSearchView",
    data(){
      return{
        grupos:[],
        produtos:[],
        produtosFiltro:[],
        tipoOrdem: '',
        termoBusca:'',
        empresa: this.$store.state.empresa
      }
    },
    components: {ProdutosContainerFlex, Card, TituloDestacado, MenuSuperior},
    created(){
      this.tipoOrdem = this.empresa.ordem_lista_produtos 
    },
    mounted()
    {
      var ls = new SecureLS();
      var itens = ls.get('gruposSecoesPromocoes');
      var produtos = [];

      let grupos=[];
      $.each(itens.grupos, function(key, value)
      {
        grupos.push(value);
      });

      grupos.forEach(res=>
      {
        $.each(res.secoes, function(key, value)
        {
          $.each(value.itens, function(key, value)
          {
            value.nomeOculto = value.nome;
            var grades = "";
            $.each(value.grades, function(key, grade)
            {
              grades += grade.grade.tamanho + " ";
            });

            if(grades){
              value.nomeOculto += " " + grades;
            }
            produtos.push(value);
          });
        });
      });
      this.produtos = produtos;
      this.produtosFiltro = produtos;

      var elmnt = document.getElementById('menusuperior-pesquisa');
      elmnt.scrollIntoView(true);
      window.scrollBy(0, -0);


      document.getElementById("bodyMain").style =
        "background-color: white";

        console.log(this.empresa.ordem_lista_produtos);

        if (this.empresa.ordem_lista_produtos == undefined)
          this.tipoOrdem = 'LIVRE'
        else
          this.tipoOrdem = this.empresa.ordem_lista_produtos        
    },
    beforeDestroy() {
      document.getElementById("bodyMain").style =
        "background-color: white" + this.$store.state.empresa.cor_secundaria;
    },
    methods:{
      Pesquisar()
      {
        this.produtosFiltro = _.filter(this.produtos, res => {
          var termo = this.termoBusca.toUpperCase();
          
          return res.nomeOculto.toUpperCase().indexOf("" + termo + '') > -1;
        });
      },
      orderProdutos(produtosFiltro, tipoordem) {
        if (tipoordem == 'MAIOR PRECO')
        return _.orderBy(produtosFiltro, ['nome','valor_final'], ['asc','desc']);

        if (tipoordem == 'MENOR PRECO')
        return _.orderBy(produtosFiltro, ['nome','valor_final'], ['asc','asc']);

        if (tipoordem == 'ALFABETICA')
        return _.orderBy(produtosFiltro, ['nome']);

        if (tipoordem == 'LIVRE')
        return _.orderBy(produtosFiltro, ['nome']);        
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/views/ProductSearchView.vue